import "./styles.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Join from "./pages/join";
import Session from "./pages/session";
import Room from "./pages/room";
import EnterRoomPage from'./pages/enterRoomPage';


export default function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Join />} />
          <Route path="/session" element={<Session />} />
          <Route path="/enterRoomPage" element={<EnterRoomPage />} />
          <Route path="/room" element={<Room />} />
        </Routes>
      </div>
    </Router>
  );
}